import { Component, OnInit } from '@angular/core'
import { MatProgressBar } from '@angular/material/progress-bar'
import { PaginationComponent } from '../../../shared/components/pagination/pagination.component'
import { TableListComponent } from '../../../shared/components/table-list/table-list.component'
import { AuthService } from '../../../core/services/auth/auth.service'
import { MatDialog } from '@angular/material/dialog'
import {
  PagedContactTypeResponse,
  SearchContactTypeModel,
} from '../../../core/models/contact-type.model'
import { FormSearchComponent } from '../../../shared/components/form-search/form-search.component'
import { MatButton } from '@angular/material/button'
import { HealthUnitService } from '../../../core/services/health-unit/location/health-unit.service'
import { MatPaginatorModule } from '@angular/material/paginator'
import { PageEvent } from '@angular/material/paginator'
import {
  MunicipalityCentralEditComponent
} from '../../../features/municipality-central/location-edit/municipality-central-edit.component';
import {
  MunicipalityCentralCreateComponent
} from '../../../features/municipality-central/location-create/municipality-central-create.component';
import {
  MunicipalityCentralService
} from '../../../core/services/municipality-central/municipality/municipality-central.service';
@Component({
  selector: 'municipality-central',
  imports: [
    MatProgressBar,
    TableListComponent,
    MatButton,
    MatPaginatorModule,
  ],
  templateUrl: './municipality-central.component.html',
  styleUrl: './municipality-central.component.scss',
  providers: [HealthUnitService, AuthService],
  standalone: true,
})
export class MunicipalityCentralComponent implements OnInit {
  constructor(
    private locationService: MunicipalityCentralService,
    private authService: AuthService,
    private dialog: MatDialog,
  ) {}

  page: number = 1
  rows: number = 10
  numberRows: number = 0
  itemsList: any[] = []
  loading: boolean = false
  searchForm: SearchContactTypeModel = new SearchContactTypeModel()
  inputSearch: string = ''
  columns: any[] = [
    {
      keyColumn: 'Nome',
      key: 'nome_fantasia',
      description: 'Nome Fantasia',
    },
    {
      keyColumn: 'razaosocial',
      key: 'razao_social',
      description: 'Razão Social',
    },
    {
      keyColumn: 'cnpj',
      key: 'cnpj',
      description: 'CNPJ',
    },
    {
      keyColumn: 'municipio',
      key: 'municipio_nome',
      description: 'Munícipio',
    },
    {
      keyColumn: 'action',
      key: { edit: true, delete: false },
      description: 'Ações',
    },
  ]
  screen: string = 'hiperdia'

  ngOnInit() {
    this.checkColumnAction()
    this.getListItems()
  }

  checkColumnAction() {
    let index = this.columns.findIndex((ele: any) => {
      return ele.keyColumn == 'action'
    })
    if (index != -1) {
      this.columns[index].key = {
        edit: this.checkPermission('editar'),
      }
      if (!Object.values(this.columns[index].key).includes(true)) {
        this.columns.splice(index, 1)
      }
    }
  }

  checkPermission(permission: string) {
    return this.authService.checkPermission(permission, this.screen)
  }

  search(event: any) {
    let search = event
    this.page = 1
    if (search) {
      this.searchForm.descricao = search
      // this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  pageChanged(page: number) {
    this.page = page
    this.uploadList()
  }

  onPageEvent(event: PageEvent) {
    this.page = event.pageIndex + 1 // pageIndex é zero-based, a sua variável page é 1-based
    this.rows = event.pageSize
    this.uploadList()
  }

  pageSizeChanged(newPageSize: number) {
    this.rows = newPageSize
    this.page = 1 // normalmente reseta para a primeira página
    this.uploadList()
  }

  uploadList(type: string = '') {
    if (type == 'new') {
      this.searchForm = new SearchContactTypeModel()
    }
    if (this.searchForm.descricao) {
      // this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  treatResponse(response: any) {
    let list = []
    const items = Array.isArray(response?.data)
      ? response.data
      : (Array.isArray(response?.items) ? response.items : (response?.data?.items ?? []))
    for (let item of items) {
      list.push(item)
    }
    this.itemsList = list
    this.numberRows = response?.paging?.total ?? response?.pagination?.total ?? response?.data?.pagination?.total ?? this.itemsList.length
  }

  // getListItems() {
  //   this.loading = true
  //   this.locationService.listPagedLocation(this.page, this.rows).subscribe({
  //     next: (response: any) => {
  //       this.treatResponse(response)
  //     },
  //     error: (err: PagedContactTypeResponse) => {},
  //     complete: () => {
  //       this.loading = false
  //     },
  //   })
  // }
  getListItems() {
    this.loading = true
    this.locationService.listPagedMunicipality(this.page,this.rows).subscribe({
      next: (response: any) => {
        this.treatResponse(response)
      },
      error: (err: PagedContactTypeResponse) => {},
      complete: () => {
        this.loading = false
      },
    })
  }

  // searchListItems() {
  //   this.loading = true
  //   this.locationService
  //     .searchMunicipality(this.page, this.rows, this.searchForm)
  //     .subscribe({
  //       next: (response: any) => {
  //         this.treatResponse(response)
  //       },
  //       error: (err: PagedContactTypeResponse) => {},
  //       complete: () => {
  //         this.loading = false
  //       },
  //     })
  // }

  newEmployee() {
    const dialogRef = this.dialog.open(MunicipalityCentralCreateComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '950px',
      // height: '100vh',
    })
    dialogRef.componentInstance.responseCreate.subscribe((response) => {
      this.uploadList()
    })
  }

  editItem(item: any) {
    const dialogRef = this.dialog.open(MunicipalityCentralEditComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '950px',
      // height: '100vh',
      data: { item },
    })
    dialogRef.componentInstance.responseEdit.subscribe((response) => {
      this.uploadList()
    })
  }

  deleteItem(item: any) {
    console.log('item delete', item)
  }
}
